import { markRaw } from 'vue';
import HomeIcon from '../../../../images/home.svg?component';
import ObserveIcon from '../../../../images/camera.svg?component';
import ReportsIcon from '../../../../images/report.svg?component';
import ReviewIcon from '../../../../images/video.svg?component';
import ScheduleIcon from '../../../../images/schedule.svg?component';
import SettingsIcon from '../../../../images/gear.svg?component';

export const MENU_ICONS = {
    HomeIcon: markRaw(HomeIcon),
    ObserveIcon: markRaw(ObserveIcon),
    ReportsIcon: markRaw(ReportsIcon),
    ReviewIcon: markRaw(ReviewIcon),
    ScheduleIcon: markRaw(ScheduleIcon),
    SettingsIcon: markRaw(SettingsIcon),
};
